/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * ChangHeon Yoo (chyoo@rsupport.com)
 *
 * @description
 *
 * @created at Thu Aug 29 2024
 **/

import { useEffect } from "react";

import { useChatRoomActions } from "@/frameworks/core/chat";
import { GROUP_POPOVER_ID, ModalID } from "@/frameworks/core/commons";
import { usePopover } from "@/frameworks/core/hooks";
import { Button, Column, Divider, Typography, useModal, useToast } from "@/frameworks/designStuff/components";
import { Properties } from "@/frameworks/libraries/properties";
import { _T } from "@rfice/language";

export default function DeletedChannel({ roomID }: { roomID: string }) {
	const chatRoomActions = useChatRoomActions();
	const toast = useToast();
	const modal = useModal();
	const popover = usePopover();
	const leave = () => {
		chatRoomActions.spaceChat.exit(roomID, Properties.browserTabID);
	};

	useEffect(() => {
		popover.hide(GROUP_POPOVER_ID.SPACE_CHAT_SUB_MENU);
		popover.hide(GROUP_POPOVER_ID.CHAT_OPTION);
		const lastModal = modal.getLast();
		if (
			lastModal &&
			(lastModal.id === ModalID.CONFIRM_POPUP || ModalID.INVITE_CHAT_MEMBER || ModalID.SHOW_CHAT_MEMBER)
		) {
			modal.hide(ModalID.CONFIRM_POPUP);
			modal.hide(ModalID.INVITE_CHAT_MEMBER);
			modal.hide(ModalID.SHOW_CHAT_MEMBER);
			toast.show({
				type: "system",
				message: _T("이 채널은 삭제되었습니다.")
			});
		}
	}, [roomID]);

	return (
		<Column gap={12} style={{ width: "100%" }}>
			<Divider type="line" />
			<Column style={{ padding: "12px 64px", width: "100%" }} horizonAlign="center" gap={12}>
				<Column>
					<Typography typoSize="Title2">{_T("해당 채널은 관리자에 의해 삭제되었습니다.")}</Typography>
					<Typography typoSize="Body2">{_T("삭제된 채널은 더이상 이용이 불가합니다.")}</Typography>
				</Column>
				<Button type="button" filled="secondary" onClick={leave}>
					{_T("채널 나가기")}
				</Button>
			</Column>
		</Column>
	);
}
